/* eslint-disable */
import { useReactToPrint } from 'react-to-print';
import React, { useEffect, useState, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import LoaderGraphic from '../utils/LoaderGraphic';
import ExportDropdown from './utils/ExportDropdown';
import CeReportFilter from './CeReportFilter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faAnglesLeft, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import Modal from 'react-modal';
import IowaReport from './IowaReport';
import ManhattanReport from './ManhattanReport';
import MinnesotaReport from './MinnesotaReport';

const CeReportContainer = (props) => {
    const componentRefs = useRef();
    const [jobIDs, setJobIDs] = useState(props.notifications["current_job_ids"] || [])
    const [toastIDs, setToastIDs] = useState(props.notifications["current_job_ids"] || [])
    const [alert, setAlert] = useState({ type: null, message: null });
    const [state, setState] = useState({
        fetch: true,
        loading: true,
        filters: {},
        filterOptions: {},
        calcs: {}
    })
    const [activePopover, setActivePopover] = useState(null);
    const [filtersModalIsOpen, setFiltersModalIsOpen] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [letterHead, setLetterHead] = useState(false);

    useEffect(() => {
        if (state.fetch) {
          let allFilters = {}
          fetchCeAggCalcs();
        };
    }, []);

    useEffect(() => {
        let checkNotificationsExist = Object.keys(props.notifications)
        if (checkNotificationsExist.length > 0) {
          Object.values(props.notifications).forEach(notification => {
            if (!Array.isArray(notification)) {
              if (notification['details']['status'] == 'complete') {
                toast(notification['body'], { progress: 0.99, onClose: () => hideCENotification(notification['id']) })
              } else {
                toast(notification['body'], { toastId: notification['details']['sidekiq_job_id'], progress: 0, onClose: () => hideCENotification(notification['id']) });
              }
            }
          })
        }
    }, [])

    useEffect(() => {
        let sideKiqJobIDs = jobIDs
        if (sideKiqJobIDs.length > 0) {

        const notificationInterval = setInterval(() => {
            if (sideKiqJobIDs.length > 0) {
                sideKiqJobIDs.forEach((jobID) => {
                    const res = getSidekiqJobStatus(jobID)
                    res.then(function (result) {
                        if (result === 'stop') {
                            sideKiqJobIDs = []
                        }
                    })
                })
            } else {
            clearInterval(notificationInterval)
            }
        }, 10000);
        }
    }, [])


    const hideCENotification = async (id) => {
        const res = await fetch(`/hide_notification/${id}`, {
        method: 'PATCH',
        headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
        }
        })

        if (!res.ok) {
            console.log(res, 'hideCEnotiBad')
        }
    }

    const getSidekiqJobStatus = async (jobID, notification = {}) => {
        const response = await fetch(`/sidekiq_status/${jobID}`, {
        headers: {
            'X-CSRF-Token': window.token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'GET',
        });
        const res = await response.json();
        // if (res['job_data']) {
        // let percentage = Number(res['job_data']['at'])

        if (res.notification?.details?.status === 'complete') {
            toast.update(jobID, { render: res['notification']['body'], progress: 0.99, autoClose: false, onClose: () => hideCENotification(res['notification']['id']) });
            setJobIDs((prevState) => {
                let newJobs = jobIDs.filter(j => j !== jobID)
                return newJobs
            })
            setToastIDs((prevState) => {
                let newJobs = toastIDs.filter(j => j !== jobID)
                return newJobs
            })
            window.location.reload(false);
            return 'stop'
        } else if (res.notification?.details?.status === 'in_progress') {
            toast.update(jobID, { progress: 40, onClose: () => hideCENotification(notification['id']) });
            return 'continue'
        } else {
            setJobIDs((prevState) => {
                let newJobs = jobIDs.filter(j => j !== jobID)
                return newJobs
            })
            setToastIDs((prevState) => {
                let newJobs = toastIDs.filter(j => j !== jobID)
                return newJobs
            })
            return 'stop'
        }
    }

    const openFiltersModal = () => {
        setFiltersModalIsOpen(true)
    }

    const closeFiltersModal = () => {
        setFiltersModalIsOpen(false)
    }

    const handleMouseEnter = (item) => {
        setActivePopover(item);
    };

    const handleMouseLeave = (item) => {
        if (item === 'leave') {
            setActivePopover(null);
        }
    };

    const fetchCeAggCalcs = async (e = null) => {
        if (e) { e.preventDefault(); }
        
        try {
            const calculations = await fetch(`/api/v1/ce_calculations`,  {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': window.token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    company_id: props.id,
                    filters: selectedFilters,
                    report: props.page,
                }),
            });

            const calcsRes = await calculations.json();

            if (!calculations.ok) {
                throw new Error('Network response was not ok');
            } else {
                setState((prevState) => {
                    return {
                        state: false,
                        loading: false,
                        ...calcsRes
                    }
                })

                setSelectedFilters(prevState => {
                    return {
                        ...prevState,
                        ...calcsRes.filters
                    }
                })
            }

            // Handle the results (e.g., update state with the results)
        } catch (error) {
            console.error('There was a problem', error);
        }
    }

    const submitCeAggCalcs = async (e) => {
        e.preventDefault()
        try {
        const res = await fetch('/calculate_ce_aggs', {
            method: 'POST',
            headers: {
            'X-CSRF-Token': window.token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            },
            // body: JSON.stringify(),
        })
        const resJson = await res.json()
        if (!res.ok) {
            throw new Error(resJson['message']);
        } else {
            toast('Working on your Peer Aggregate Calculations for all reports! Please wait a few minutes for them to complete.', { toastId: resJson['job_id'], progress: 0.05 });
            let sideKiqJobIDs = [...jobIDs, resJson['job_id']]
            const singleJobInterval = setInterval(() => {
                if (sideKiqJobIDs.includes(resJson['job_id'])) {
                    const ress = getSidekiqJobStatus(resJson['job_id'], resJson['notification'])
                    ress.then(function (result) {
                        if (result === 'stop') {
                            sideKiqJobIDs = []
                        }
                    })
                } else {
                clearInterval(singleJobInterval)
                }
            }, 10000);
        }

        } catch (error) {
            setAlert({ type: 'error', message: error.message })
        }
    }

    const renderAlertPopUp = () => {
        if (alert.type === 'success') {
        return (
            <div className='alert alert-success alert-div' role='alert'>
            {alert.message}
            <button onClick={() => setAlert({ type: null, message: null })}><i className='fa fa-times'></i></button>
            </div>
        )
        }
        if (alert.type === 'error') {
        return (
            <div className='alert alert-danger alert-div' role='alert'>
            {alert.message}
            <button onClick={() => setAlert({ type: null, message: null })}><i className='fa fa-times'></i></button>
            </div>
        )
        }
    }

    const capitalizedTitle = props.page ? props.page.charAt(0).toUpperCase() + props.page.slice(1) : '';

    const renderReport = (page = props.page) => {
        const Component = {
          iowa: IowaReport,
          manhattan: ManhattanReport,
          minnesota: MinnesotaReport
        }[props.page];

        const dateIssFormatted = props.date_issued ? moment(props.date_issued).format("MMMM D, YYYY") : null
        return (
          <Component
            {...props}
            calcs={state.calcs}
            filters={state.filters}
            dateIssued={dateIssFormatted}
            letterHead={letterHead}
          />
        );
    }

    const handlePrint = useReactToPrint({
        contentRef: componentRefs,
        documentTitle: `${props.real_name} - ${capitalizedTitle} Report.pdf`,
    });

    return (
        <div>
            {alert.message ? renderAlertPopUp() : null}
            <ToastContainer
                position='top-right'
                autoClose={false}
                closeButton={true}
                closeOnClick={false}
            />
            <div id='sticky-topnav-left-btns'>
                <button id='printIcon' className='print-pdf-btn' onClick={handlePrint} aria-hidden='true'><FontAwesomeIcon icon={faFilePdf} /></button>
            </div>
            <div id='sticky-topnav-right-btns'>
                <button className='hide-on-print' onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faQuestionCircle} /></button>
            </div>
            <div id='sticky-side-btns'>
                <span
                className='filters-btn-span hide-on-print'
                onMouseEnter={() => handleMouseEnter('filters')}
                onMouseLeave={() => handleMouseLeave('leave')}
                >
                <button className='filters-btn'><FontAwesomeIcon icon={faAnglesLeft} onClick={() => openFiltersModal()} /></button>
                {activePopover === 'filters' && (
                    <div className='filters-popover'>
                    Display Filters
                    </div>)}
                </span>
            </div>
            <button id='ce-letterhead-button' onClick={() => setLetterHead(!letterHead)}>{letterHead ? `Letterhead ON`: `Letterhead OFF`}</button>
            <Modal
                className={{
                    base: 'client-modal-content',
                    afterOpen: 'client-modal-content_after-open',
                    beforeClose: 'client-modal-content_before-close',
                }}
                overlayClassName={{
                    base: 'overlay-base',
                    afterOpen: 'overlay-base_after-open',
                    beforeClose: 'overlay-base_before-close',
                }}
                isOpen={filtersModalIsOpen}
                onRequestClose={closeFiltersModal}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={0}
                contentLabel='Cain Ellsworth Report Filters Modal'
                >
                <div>
                    <header className='company-modal-header'>
                        <h1 className='client-company-name'>Report Filters</h1>
                    </header>
                    <div className='report-filters-container'>
                        <div className='client-info-div'>
                            {props.client_name ? <p>CLIENT ID: {props.client_name}</p> : null}
                            {props.real_name ? <p>CLIENT NAME: {props.real_name}</p> : null}
                            <p>NAICS: {props.code}, {props.industry}</p>
                        </div>
                        <CeReportFilter 
                            filterOptions={state.filterOptions} 
                            handleFilterSubmit={fetchCeAggCalcs} 
                            selectedFilters={selectedFilters} 
                            setSelectedFilters={setSelectedFilters}
                        />
                    </div>
                </div>
            </Modal>
            <button onClick={(e) => submitCeAggCalcs(e)}>Run Peer Aggregate Calcs for Reports</button>
            <div ref={componentRefs}>
                {renderReport()}
            </div>
        </div>
    )
}

export default CeReportContainer;